import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom'

const Panel = ({ children, label = false, icon, className = '', cardClass = 'card', headerAccessory = null }) => {
    const displayIcon = icon || faHiveIconSmallLight

    return (
        <div className={`${cardClass} ${className}`}>
            {label &&
                <div className="card-header">
                    <FontAwesomeIcon icon={displayIcon} />
                    <span>{label}</span>
                    {headerAccessory}
                </div>
            }
            {children}
        </div>
    )
}
export default Panel
